export const Share = { open: () => {} };
